export default function ShopIcon() {
    return (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.96826 14.4658H31.2452C32.3985 14.4658 33.3334 15.4008 33.3334 16.5541C33.3334 16.7515 33.3055 16.9479 33.2503 17.1374L29.9091 28.6229C29.6497 29.5146 28.8326 30.1278 27.9039 30.1278H15.0918C14.1632 30.1278 13.3461 29.5146 13.0867 28.6229L8.96826 14.4658Z"
                stroke="#010101"
                strokeWidth="2"
                strokeLinecap="round"
            />
            <path
                d="M9.59806 16.5542L8.42695 12.7999C8.15484 11.9276 7.34719 11.3335 6.43342 11.3335H3.33325"
                stroke="#010101"
                strokeWidth="2"
                strokeLinecap="round"
            />
            <path
                d="M14.9999 36.3333C15.9204 36.3333 16.6666 35.5871 16.6666 34.6667C16.6666 33.7462 15.9204 33 14.9999 33C14.0794 33 13.3333 33.7462 13.3333 34.6667C13.3333 35.5871 14.0794 36.3333 14.9999 36.3333Z"
                fill="#010101"
            />
            <path
                d="M28.3332 36.3333C29.2536 36.3333 29.9998 35.5871 29.9998 34.6667C29.9998 33.7462 29.2536 33 28.3332 33C27.4127 33 26.6665 33.7462 26.6665 34.6667C26.6665 35.5871 27.4127 36.3333 28.3332 36.3333Z"
                fill="#010101"
            />
            <path d="M17.3213 19.7056V24.9302" stroke="#F7A40A" strokeWidth="2" strokeLinecap="round" />
            <path d="M21.4978 19.7056V24.9302" stroke="#F7A40A" strokeWidth="2" strokeLinecap="round" />
            <path d="M25.6743 19.7056V24.9302" stroke="#F7A40A" strokeWidth="2" strokeLinecap="round" />
            <rect x="21.9988" y="7.77344" width="4.2445" height="0.639151" fill="#F7A40A" stroke="#F7A40A" strokeWidth="0.3" />
            <path d="M26.2374 10.0058H22.6047V10.8017V11.5946H21.9988V10.0058V9.36963H26.2374V10.0058Z" fill="#F7A40A" stroke="#F7A40A" strokeWidth="0.3" />
            <path d="M21.4086 8.40478H17.1641V7.76562H21.4086V8.40478Z" fill="#F7A40A" stroke="#F7A40A" strokeWidth="0.3" />
            <path d="M21.4026 10.0034H17.1641V9.36426H21.4026V10.0034Z" fill="#F7A40A" stroke="#F7A40A" strokeWidth="0.3" />
            <path d="M21.4026 10.9619V11.6011H17.1641V10.9619H21.4026Z" fill="#F7A40A" stroke="#F7A40A" strokeWidth="0.3" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M25.8371 13.5C26.8073 12.4486 27.4 11.0435 27.4 9.5C27.4 6.24152 24.7585 3.6 21.5 3.6C18.2415 3.6 15.6 6.24152 15.6 9.5C15.6 11.0435 16.1927 12.4486 17.1629 13.5H15.1546C14.4232 12.3423 14 10.9706 14 9.5C14 5.35786 17.3579 2 21.5 2C25.6421 2 29 5.35786 29 9.5C29 10.9706 28.5768 12.3423 27.8454 13.5H25.8371ZM21.5236 17H21.4764C21.4843 17 21.4921 17 21.5 17C21.5079 17 21.5157 17 21.5236 17Z"
                fill="#F7A40A"
            />
        </svg>
    );
}
